import React, { createContext, useContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const AlertContext = createContext();

export const useAlerta = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alerta, setAlerta] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const mostrarAlerta = (message, severity = "success") => {
    setAlerta({
      open: true,
      message,
      severity,
    });
  };

  const handleClose = () => {
    setAlerta((prev) => ({ ...prev, open: false }));
  };

  return (
    <AlertContext.Provider value={{ mostrarAlerta }}>
      {children}

      <Snackbar
        open={alerta.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleClose}
          severity={alerta.severity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {alerta.message}
        </MuiAlert>
      </Snackbar>
    </AlertContext.Provider>
  );
};